import { useState } from "react";

import { Descriptions, Flex, Divider, Space, Typography } from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";
import CustomTreeSelect from "@/components/inputs/CustomTreeSelect";

import { FILTER_NAMES, ACCESS_LEVELS } from "@/constants/tasks";

export const FiltersModalContent = ({
  isAdmins,
  tempValueFilters,
  units,
  unitsTree,
  authors,
  user,
  handleTempFilterChange,
}) => {
  const [authorSelectOpen, setAuthorSelectOpen] = useState(false);

  return (
    <Descriptions
      column={1}
      colon={false}
      styles={{
        label: {
          display: "inline-block",
          minWidth: "150px",
          color: "#777777",
        },
        content: {
          display: "block",
          marginLeft: "8px",
        },
      }}
    >
      {isAdmins ? (
        <Descriptions.Item label="Рабочая группа">
          <CustomSelect
            placeholder="Начните вводить"
            options={units}
            fieldNames={{
              label: "name",
              value: "uuid",
              key: "uuid",
            }}
            style={{ width: "100%" }}
            showSearch
            optionFilterProp="name"
            allowClear
            popupMatchSelectWidth={false}
            value={tempValueFilters?.unit_uuid}
            onChange={(unit) =>
              handleTempFilterChange(FILTER_NAMES.UNIT_UUID, unit)
            }
          />
        </Descriptions.Item>
      ) : (
        <>
          <Descriptions.Item label="Рабочая группа">
            <CustomTreeSelect
              placeholder="Начните вводить"
              data={unitsTree}
              value={tempValueFilters?.units_uuids}
              onChange={(units_uuids) => {
                handleTempFilterChange(FILTER_NAMES.UNITS_UUIDS, units_uuids);
              }}
              style={{ width: "100%" }}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Тип">
            <CustomSelect
              options={ACCESS_LEVELS}
              style={{ width: "100%" }}
              popupMatchSelectWidth={false}
              value={tempValueFilters?.access_level}
              onChange={(val) =>
                handleTempFilterChange(FILTER_NAMES.ACCESS_LEVEL, val)
              }
              optionRender={(option) => (
                <Flex gap={5} align="center">
                  {option?.data?.icon}
                  <span>{option.label}</span>
                </Flex>
              )}
              labelRender={(option) => {
                const item = ACCESS_LEVELS.find(
                  (item) => item.value === option.value,
                );
                return (
                  <Flex gap={5} align="center">
                    {item?.icon}
                    <span>{item.label}</span>
                  </Flex>
                );
              }}
            />
          </Descriptions.Item>
        </>
      )}

      <Descriptions.Item label="Автор">
        <CustomSelect
          open={authorSelectOpen}
          onOpenChange={setAuthorSelectOpen}
          placeholder="Начните вводить"
          value={tempValueFilters?.author_uuid}
          options={authors}
          showSearch
          allowClear
          fieldNames={{ value: "uuid" }}
          optionFilterProp="label"
          style={{ width: "100%" }}
          placement="topRight"
          popupMatchSelectWidth={false}
          onChange={(val) =>
            handleTempFilterChange(FILTER_NAMES.AUTHOR_UUID, val)
          }
          popupRender={(menu) => (
            <>
              {menu}
              {authors.map((u) => u.uuid).includes(user.employee_uuid) && (
                <>
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Typography.Link
                      onClick={() => {
                        handleTempFilterChange(
                          FILTER_NAMES.AUTHOR_UUID,
                          user.employee_uuid,
                        );
                        setAuthorSelectOpen(false);
                      }}
                    >
                      Я автор
                    </Typography.Link>
                  </Space>
                </>
              )}
            </>
          )}
        />
      </Descriptions.Item>
    </Descriptions>
  );
};
